export interface User {
    name: string;
    email: string;
    phone: string;
    website: string;
}

export interface UploadedFile {
    id: number;
    agency: string;
    uploadedBy: string;
    uploadDate: string;
    fileName: string;
    submissionPeriod: string;
    status: string;
}

export interface Ori {
    ori: string;
    agency: string;
    oriAgency: string;
}

export interface UploadedFileDetails {
    id: number;
    ori: string;
    createdOn: string;
    createdBy: string;
    source: string;
    processedOn: string;
    fileName: string;
    errorCode: string;
    errorCount: number;
    errorMessage: string;
    status: string;
    statusLabel: string;
    warningCount: number;
    errorsAndWarnings: UploadedFileWarningsAndErrors[];
    fileStatistics: FileStatistics[];
    failedFileDetails: FailedFileDetails[];
}

export interface FailedFileDetails {
    lineNumber: number;
    errorCode: string;
    description: string;
}

export interface FetchValidationMessagesResponse {
    total: number;
    validationMessages: FailedFileDetails[];
}

export interface UploadedFileWarningsAndErrors {
    agency: string;
    ori: string;
    "incidentNumber": string;
    "stopNumber": string;
    "lineNumber": string;
    "errorCode": string;
    type: string;
    description: string;
    isZeroReport: boolean;
}

export interface VItem {
    text: string;
    value: any;
    [x: string]: any;
}

export interface FileStatistics {
    type: string;
    submitted: number;
    rejected: number;
    rejectionRate: number;

}

export interface SelectItem {
    label: string;
    value: any;
    isDisable: boolean;
}

export type SelectValue = {
    value: any;
};

export interface AgeRange {
    upper: number;
    lower: number;
}

export interface SelectorMode {
    type: SelectEntryType;
    label: string;
    isDefaultSelection: boolean;
}

export enum SelectEntryType {
    Add = "add",
    Edit = "edit",
    Zero = "zero",
    Delete = "delete"
}

export enum UploadType {
    nibrs,
    summary,
    useOfForce,
    narrative,
    policeEmployee,
    contacts,
    communityPolicing,
    population
}

export interface QueueQueryResult {
    total: number;
    pageNumber: number;
    itemsPerPage: number;
    data: QueueItem[];
}

export interface QueueItem {
    status: string;
    type: string;
    start: Date;
    end: Date;
}
export interface AgencyType {
    code: string;
    label: string;
}

export interface PopulationProfile {
    profileName: string;
    loaderType: number;
    options: string;
    excludedAgencyTypes: string[];
}
